import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDisketteIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.96447 20.5355C5.42893 22 7.78595 22 12.5 22C17.214 22 19.5711 22 21.0355 20.5355C22.5 19.0711 22.5 16.714 22.5 12C22.5 11.6585 22.5 11.4878 22.4848 11.3142C22.4142 10.5049 22.086 9.71257 21.5637 9.09034C21.4516 8.95687 21.328 8.83317 21.0806 8.58578L15.9142 3.41944C15.6668 3.17206 15.5431 3.04835 15.4097 2.93631C14.7874 2.414 13.9951 2.08581 13.1858 2.01515C13.0122 2 12.8415 2 12.5 2C7.78595 2 5.42893 2 3.96447 3.46447C2.5 4.92893 2.5 7.28595 2.5 12C2.5 16.714 2.5 19.0711 3.96447 20.5355Z",
			stroke: "white",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5 22V21C17.5 19.1144 17.5 18.1716 16.9142 17.5858C16.3284 17 15.3856 17 13.5 17H11.5C9.61438 17 8.67157 17 8.08579 17.5858C7.5 18.1716 7.5 19.1144 7.5 21V22",
			stroke: "white",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M7.5 8H13.5",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		})
	]
});
export default SvgDisketteIcon;
